import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RentalPolicyRepository } from '@/core/domain/rental-policy/repositories/rental-policy.respository';
import { GetRentalPolicyUseCase } from '@/core/domain/rental-policy/usecases/getRentalPolicy.usecase';
import { RentalPolicyImplRepository } from './rental-policy-imp.respository';

const getRentalPolicyUseCaseFactory = (repository: RentalPolicyRepository) =>
    new GetRentalPolicyUseCase(repository);

@NgModule({
    imports: [CommonModule],
    providers: [
        {
            provide: GetRentalPolicyUseCase,
            useFactory: getRentalPolicyUseCaseFactory,
            deps: [RentalPolicyImplRepository],
        },
        {
            provide: RentalPolicyRepository,
            useClass: RentalPolicyImplRepository,
        },
    ],
})
export class RentalPolicyDataModule {}
